export default __webpack_public_path__ + "static/media/check-16.c1d09f4b.svg";